import InArticleAdsenseComponent from './InArticleAdsenseComponent.vue'

const InArticleAdsense = {
  install: (app, options) => {
    app.component('InArticleAdsense', InArticleAdsenseComponent)
  },
}

export default InArticleAdsense
